import {RouteAuthRanges, RouteEffectTypes} from '../enum/index'

/**
 * 路由配置中的meta对象
 * @class
 */
export default class RouteMeta{
	
	/**
	 * @constructor
	 * @param {Object} args
	 */
	constructor({range = RouteAuthRanges.NORMAL, auth = false, title = '', effect = RouteEffectTypes.SLIDER_LEFT} = {}) {
		this.range = range //页面类型(通用、微信专用或App)
		this.auth = auth //是否需要身份校验
		this.title = title //页面标题
		this.effect = effect //路由进入时的动画效果
	}
}